export const getLinkFromHrefLang = (urlOrPath: string): string => {
  const isUrl = /(http(s?)):\/\//i.test(urlOrPath)
  if (isUrl) {
    return urlOrPath
  }

  return `${process.env.baseUrl}${urlOrPath}`
}
